import React from 'react'

export default function Hero() {
  return (
    <>
      {/* ── Main Hero ── */}
      <section className="hero">
        <div className="hero-bg" aria-hidden="true"></div>
        <div className="hero-overlay" aria-hidden="true"></div>

        <div className="hero-content fade-in">
          <div className="hero-eyebrow">
            <i className="bi bi-globe-americas"></i>
            Pan-African Nonprofit &mdash; Est. 2024
          </div>

          <h1 className="hero-headline">
            Building Futures Through<br />
            <span className="accent">Football &amp; Education</span>
          </h1>

          <p className="hero-sub">
            Schools In Soccer Development Initiative empowers children across Africa
            through school-based football programs that integrate quality training with
            education — shaping disciplined, confident, and well-rounded individuals.
          </p>

          <div className="hero-actions">
            <a href="/donate" className="btn btn-accent btn-lg">
              <i className="bi bi-heart-fill"></i> Donate Now
            </a>
            <a href="/about" className="btn btn-outline btn-lg">
              Learn More
            </a>
            <a href="/get-involved" className="btn btn-outline btn-lg">
              Get Involved
            </a>
          </div>
        </div>
      </section>

      {/* ── Impact Stats Bar ── */}
      <div className="stats-bar">
        <div className="stats-bar-inner">
          <div className="stat-item">
            <i className="bi bi-people-fill stat-icon"></i>
            <span className="stat-number counter" data-target="500">0</span>
            <span className="stat-label">Students Reached</span>
          </div>
          <div className="stat-item">
            <i className="bi bi-building stat-icon"></i>
            <span className="stat-number counter" data-target="10">0</span>
            <span className="stat-label">Schools Partnered</span>
          </div>
          <div className="stat-item">
            <i className="bi bi-trophy-fill stat-icon"></i>
            <span className="stat-number counter" data-target="3">0</span>
            <span className="stat-label">Programs Running</span>
          </div>
          <div className="stat-item">
            <i className="bi bi-heart-fill stat-icon"></i>
            <span className="stat-number counter" data-target="3">0</span>
            <span className="stat-label">Communities Served</span>
          </div>
        </div>
      </div>
    </>
  )
}
